import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { Protected, RoleHome } from "./components/Protected";
import Landing from "./pages/shared/Landing";
import Login from "./pages/shared/Login";
import ClubLogin from "./pages/shared/ClubLogin";
import MatchdayPage from "./pages/shared/MatchdayPage";
import ClubDashboard from "./pages/club/ClubDashboard";
import SponsorPortal from "./pages/sponsor/SponsorPortal";
import PlatformOwner from "./pages/platform/PlatformOwner";

function App() {
    // Subdomain routing: when accessed at {slug}.floodlight.club, render the
    // tenant-branded login page directly. Falls back to normal app routing on
    // root domains and dev hosts.
    const host = typeof window !== "undefined" ? window.location.hostname : "";
    const parts = host.split(".");
    const reservedSubs = new Set(["www", "floodlight", "app", "admin", "api", "localhost"]);
    const isFloodlightDomain = host.endsWith("floodlight.club");
    const candidate = parts.length > 2 ? parts[0].toLowerCase() : null;
    const subdomainSlug = isFloodlightDomain && candidate && !reservedSubs.has(candidate) ? candidate : null;

    return (
        <div className="App bg-[var(--sb-page)] text-white antialiased">
            <AuthProvider>
                <BrowserRouter>
                    {subdomainSlug ? (
                        <Routes>
                            <Route path="/sponsor" element={<Protected roles={["sponsor"]}><SponsorPortal /></Protected>} />
                            <Route path="/club" element={<Protected roles={["platform_owner", "club_admin"]}><ClubDashboard /></Protected>} />
                            <Route path="/platform" element={<Protected roles={["platform_owner"]}><PlatformOwner /></Protected>} />
                            <Route path="/app" element={<RoleHome />} />
                            <Route path="*" element={<ClubLogin slugOverride={subdomainSlug} />} />
                        </Routes>
                    ) : (
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/c/:slug" element={<ClubLogin />} />
                            <Route path="/app" element={<RoleHome />} />
                            <Route path="/platform" element={<Protected roles={["platform_owner"]}><PlatformOwner /></Protected>} />
                            <Route path="/club" element={<Protected roles={["platform_owner", "club_admin"]}><ClubDashboard /></Protected>} />
                            <Route path="/sponsor" element={<Protected roles={["sponsor"]}><SponsorPortal /></Protected>} />
                            {/* Vanity short link: /<slug> falls through to ClubLogin. Reserved app paths above always win. */}
                            <Route path="/:slug/spots" element={<MatchdayPage />} />
                            <Route path="/:slug" element={<ClubLogin />} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    )}
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
